import { DefaultLayout } from '@fondationcss/ui';

export const getCustomRoutes = () => [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: 'Osmos' },
    children: [
      {
        name: 'default-home',
        path: '',
        component: () => import('@/views/default-view.vue'),
        meta: { hideFooter: true },
      },
      {
        name: 'student-dashboard',
        path: 'student',
        component: () => import('@/views/student-dashboard-view.vue'),
        meta: { title: 'Tableau de bord', hideFooter: true },
      },
      {
        name: 'admin-dashboard',
        path: 'admin',
        component: () => import('@/views/admin-dashboard-view.vue'),
        meta: { title: 'Tableau de bord', hideFooter: true },
      },
      {
        name: 'admin-activity',
        path: 'admin/activity',
        component: () => import('@/views/admin-activity-view.vue'),
        meta: { title: 'Activité des apprenants', hideFooter: true },
      },
      {
        name: 'access-management',
        path: 'admin/access',
        component: () => import('@/views/admin/access-view.vue'),
        meta: { title: 'Gestion des accès', hideFooter: true },
      },
      {
        name: 'help-article-edit',
        path: 'help/articles/:id',
        component: () => import('@/views/help/help-article-edit-view.vue'),
        meta: { title: 'Article d\'aide', hideFooter: true },
      },
      {
        name: 'help-playground',
        path: 'help/playground',
        component: () => import('@/views/help/help-playground-view.vue'),
        meta: { title: 'Banc d\'essai du widget', hideFooter: true },
      },
      {
        name: 'catalog',
        path: 'catalog',
        component: () => import('@/views/catalog/catalog-view.vue'),
        meta: { title: 'Catalogue', hideFooter: true },
      },
      {
        name: 'catalog-project',
        path: 'catalog/projects/:id',
        component: () => import('@/views/catalog/catalog-project-view.vue'),
        meta: { title: 'Projet', hideFooter: true },
      },
      {
        name: 'catalog-module',
        path: 'catalog/modules/:id',
        component: () => import('@/views/catalog/catalog-module-view.vue'),
        meta: { title: 'Module', hideFooter: true },
      },
      {
        name: 'authoring-projects',
        path: 'authoring/projects',
        component: () => import('@/views/projects/projects-view.vue'),
        meta: { title: 'Projets', hideFooter: true },
      },
      {
        name: 'authoring-project-detail',
        path: 'authoring/projects/:id',
        component: () => import('@/views/projects/project-detail-view.vue'),
        meta: { title: 'Projet', hideFooter: true },
      },
      {
        name: 'authoring-module-detail',
        path: 'authoring/modules/:id',
        component: () => import('@/views/authoring/module-detail-view.vue'),
        meta: { title: 'Module', hideFooter: true },
      },
      {
        name: 'authoring-page-detail',
        path: 'authoring/pages/:id',
        component: () => import('@/views/authoring/page-detail-view.vue'),
        meta: { title: 'Page', hideFooter: true },
      },
    ],
  },
];
